import { alpha } from '@material-ui/core';
import { ColorPalette } from './ColorPalette';

export function adjustTextColor(
  palette: ColorPalette,
  blackAlpha: number,
  whiteAlpha: number
): string {
  const originalColor = palette.textColor[0] ?? '#FFFFFF';
  if (!blackAlpha && !whiteAlpha) return originalColor;
  if (originalColor === '#FFFFFF' && whiteAlpha) return alpha(originalColor, whiteAlpha);
  if (originalColor === '#000000' && blackAlpha) return alpha(originalColor, blackAlpha);
  return originalColor;
}
